import React, { useState } from 'react';
import { GoalType } from './AddGoalFlow';
import { Icon } from '../Icon';
import './GoalTypeSelector.css';

interface GoalTypeSelectorProps {
  value?: GoalType;
  onChange: (type: GoalType) => void;
  onNext: () => void;
  onBack: () => void;
}

export const GoalTypeSelector: React.FC<GoalTypeSelectorProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const [selectedType, setSelectedType] = useState<GoalType | undefined>(value);
  
  const handleSelect = (type: GoalType) => {
    setSelectedType(type);
    onChange(type);
  };

  const goalTypes = [
    {
      id: 'with_amount' as GoalType,
      iconName: 'target',
      title: 'Цель с суммой',
      description: 'Накопить определённую сумму',
      example: 'Например: 100,000 на отпуск'
    },
    {
      id: 'piggybank' as GoalType,
      iconName: 'goal-piggy-bank',
      title: 'Копилка',
      description: 'Откладывать без конкретной суммы',
      example: 'Например: резервный фонд'
    }
  ];

  return (
    <div className="goal-type-selector step-content">
      <div className="goal-type-selector__header">
        <button className="goal-type-selector__back" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="goal-type-selector__header-content">
          <h2 className="goal-type-selector__title">Тип цели</h2>
          <p className="goal-type-selector__subtitle">
            Выберите как будете копить
          </p>
        </div>
      </div>

      <div className="goal-type-selector__options">
        {goalTypes.map((type) => (
          <button
            key={type.id}
            className={`goal-type-option ${selectedType === type.id ? 'goal-type-option--selected' : ''}`}
            onClick={() => handleSelect(type.id)}
          >
            <div className="goal-type-option__icon">
              <Icon name={type.iconName} size={40} />
            </div>
            <div className="goal-type-option__content">
              <div className="goal-type-option__title">{type.title}</div>
              <div className="goal-type-option__description">{type.description}</div>
              <div className="goal-type-option__example">{type.example}</div>
            </div>
            <div className="goal-type-option__check">
              {selectedType === type.id && <Icon name="check" size={20} />}
            </div>
          </button>
        ))}
      </div>

      <button
        className="goal-type-selector__next"
        onClick={onNext}
        disabled={!selectedType}
      >
        Далее
      </button>
    </div>
  );
};

